import { PlusIcon } from "@xola/icons";
import { Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Permission } from "types";
import { IsGranted } from "./IsGranted";

export const CreatePurchaseButton = ({ label }: { label?: string }) => {
    const history = useHistory();

    const handleButtonClick = () => {
        history.push("/cart/init");
    };

    return (
        <IsGranted permissions={Permission.ADD_BOOKING_VIEW}>
            <Button color="success" icon={<PlusIcon />} onClick={handleButtonClick}>
                {label ?? "Make a Purchase"}
            </Button>
        </IsGranted>
    );
};
